import loadable from '@loadable/component';

export const MovementPageLoadable = loadable(() => import('./MovementPage'), {
  resolveComponent: (module) => module.MovementPage,
});
